import Phaser from "phaser";
import LevelBase from "./levelBase";
import { Exit, Interactive, Player, Torch } from "../objects";
import { translate } from "../../utils/localization";
import GreenExplosion from "../objects/Abushgidim/GreenExplosion";
import {
  CLASS_NAMES,
  DIRS,
  PIXEL_NAME,
  PIXEL_TO_TILEMAP_POSITION,
  SCALE,
  TICK_TIME,
  TILE_SIZE,
} from "../../utils/constants";
import UI from "../UI";
import Abushgidim from "../objects/Abushgidim/index.js";
import BranchChunk from "../objects/Abushgidim/BranchChunk";
import CircularProgress from "../CircularProgress/CircularProgress";
import BranchesEnergyBars from "../BranchesEnergyBars/BranchesEnergyBars";

class LevelKiFinale extends LevelBase {
  constructor() {
    super();
    this.name = "The prophecy";
    this.diamondsGoal = 0;
    this.worldArtOriginPos = { x: 14, y: 15 };
    this.reloadSpots = [];
    this.batBirthSpots = [];
    this.stepsToBossGrowth = 10;
    this.stepCount = 0;
    this.artSpot = null;
    // flag to indicate the player was killed by the boss and take action after reconnect
    this.playerKilled = false;
    this.ticksCountForBossLoop = 50;
    this.ticksCount = 50;
    this.flash = null;
    this.isRestart = true;

    // gidim = spirit
    // Abu = minor god father of plants and vegetation
    // Abushgidim => the bad root of then father of plants

    this.circularProgress = null;
  }

  get id() {
    return this.constructor.key;
  }

  async connectToScene(scene) {
    await super.connectToScene(scene);
    scene.ui.drawKiBossScores();
    this.circularProgress = new CircularProgress(scene);
    this.branchesEnergyBars = new BranchesEnergyBars(scene);

    // this.circularProgress.draw({
    //   x: UI.tileToScreen(19.15),
    //   y: UI.tileToScreen(1),
    //   radius: UI.tileToScreen(0.5),
    // });
    // this.branchesEnergyBars.draw({
    //   x: UI.tileToScreen(1.5),
    //   y: UI.tileToScreen(0.5),
    // });
    this.scene.children.getByName("score_left_img").setVisible(false);
    this.scene.children.getByName("score_right_img").setVisible(false);

    this.drawProfecy();
    // pan little higher so art can be fully seen
    // this.focusObject = {
    //   ...this.player.alien,
    //   y: this.player.alien.y - UI.tileToPixels(3),
    // };

    this.boss = new Abushgidim(this, {
      // half between 2 birth spots
      x:
        Math.min(
          this.batBirthSpots[0].position.x,
          this.batBirthSpots[1].position.x
        ) +
        Math.abs(
          this.batBirthSpots[0].position.x - this.batBirthSpots[1].position.x
        ) /
          2,
      // same level as birth spots
      y: this.batBirthSpots[0].position.y,
    });

    this.battleMusic = this.scene.sound.add("escape_music", {
      loop: true,
      valume: 0,
    });

    if (this.scene.isRestart) {
      this.jumpToBattle();
    }

    this.prepareDwarfForProphecy();

    // // UNCOMMENT FOR TEST
    // this.scene.input.keyboard.addListener("keyup", this.onKeyUp.bind(this));
    // this.boss.rightBranch.chunks = []

    // let chunk = new BranchChunk(this.boss, this.boss.rightBranch.id, 0x00ff00);
    // chunk.setPosition({ x: this.artSpot.position.x - 6, y: this.artSpot.position.y-2});
    // this.boss.rightBranch.chunks.push(chunk);
    // // this.drawSmallRosette({ x: this.player.position.x - 6, y: this.player.position.y-2}, this.boss.rightBranch)

    // this.boss.rightBranch.chunks.forEach(ch => ch.animGrow())

    await this.awaitTicks(2);

    // this.startBattle()
    // this.bossLoop();
    // this.bossDefeated()
  }
  async jumpToBattle() {
    this.player.setPosition({
      x: this.artSpot.position.x,
      y: this.artSpot.position.y + 3,
    });
    this.moveObject(this.player, this.player.position);
    this.focusObject = this.player.alien;
    // this.scene.rules.setUpCameraFollow(this.player.alien)
    // pan camera to player
    // setTimeout(() => this.scene.rules.panAndFollow(this.player.alien), 0)

    this.leader.setPosition({
      x: this.artSpot.position.x + 2,
      y: this.artSpot.position.y,
    });
    this.moveObject(this.leader, this.leader.position);
    this.leader.animIdle();
    this.destroyObjectsInRange(
      {
        x1: this.artSpot.position.x - 1,
        x2: this.artSpot.position.x + 2,
        y1: this.artSpot.position.y,
        y2: this.artSpot.position.y + 2,
      },
      1
    );
    await this.awaitTicks(2);
    this.startBattle();
  }

  prepareDwarfForProphecy() {
    const line = this.artSpot.position.x + 1 - this.leader.position.x;
    for (let i = 1; i <= line; i++) {
      this.leader.leadingPath.push({
        x: this.leader.position.x + i,
        y: this.leader.position.y,
      });
    }
  }

  startBattle() {
    this.pause();

    this.circularProgress.draw({
      x: UI.tileToScreen(19.15),
      y: UI.tileToScreen(0),
      radius: UI.tileToScreen(0.5),
    });
    this.branchesEnergyBars.draw({
      x: UI.tileToScreen(1.5),
      y: UI.tileToScreen(-0.5),
    });
    this.scene.children.getByName("score_left_img").setVisible(true);
    this.scene.children.getByName("score_right_img").setVisible(true);

    this.scene.tweens.add({
      targets: this.scene.rules.music,
      volume: 0,
      ease: "Linear",
      duration: 1000,
    });
    this.scene.rules?.music?.stop();

    this.battleMusic?.play();
    this.scene.tweens.add({
      targets: this.battleMusic,
      volume: 1,
      ease: "Linear",
      duration: 1000,
    });
    this.bossLoop();
    // this.bossDefeated()
  }

  growLeft() {
    let chunk = new BranchChunk(this.boss, this.boss.rightBranch.id, 0x00ff00);
    const prevChunk =
      this.boss.rightBranch.chunks[this.boss.rightBranch.chunks.length - 1];
    chunk.setPosition({ x: prevChunk.position.x - 1, y: prevChunk.position.y });
    this.boss.rightBranch.chunks.push(chunk);

    this.boss.rightBranch.chunks.forEach((ch) => ch.animGrow());
  }

  growRight() {
    let chunk = new BranchChunk(this.boss, this.boss.rightBranch.id, 0x00ff00);
    const prevChunk =
      this.boss.rightBranch.chunks[this.boss.rightBranch.chunks.length - 1];
    chunk.setPosition({ x: prevChunk.position.x + 1, y: prevChunk.position.y });
    this.boss.rightBranch.chunks.push(chunk);

    this.boss.rightBranch.chunks.forEach((ch) => ch.animGrow());
  }

  growUp() {
    let chunk = new BranchChunk(this.boss, this.boss.rightBranch.id, 0x00ff00);
    const prevChunk =
      this.boss.rightBranch.chunks[this.boss.rightBranch.chunks.length - 1];
    chunk.setPosition({ x: prevChunk.position.x, y: prevChunk.position.y - 1 });
    this.boss.rightBranch.chunks.push(chunk);

    this.boss.rightBranch.chunks.forEach((ch) => ch.animGrow());
  }

  growDown() {
    let chunk = new BranchChunk(this.boss, this.boss.rightBranch.id, 0x00ff00);
    const prevChunk =
      this.boss.rightBranch.chunks[this.boss.rightBranch.chunks.length - 1];
    chunk.setPosition({ x: prevChunk.position.x, y: prevChunk.position.y + 1 });
    this.boss.rightBranch.chunks.push(chunk);

    this.boss.rightBranch.chunks.forEach((ch) => ch.animGrow());
  }

  drawSmallRosette(oPos, branch) {
    let chunk = new BranchChunk(this.boss, this.boss.rightBranch.id, 0x00ff00);
    chunk.setPosition({ x: oPos.x, y: oPos.y });
    this.boss.rightBranch.chunks.push(chunk);

    chunk = new BranchChunk(this.boss, this.boss.rightBranch.id, 0x00ff00);
    chunk.setPosition({ x: oPos.x - 1, y: oPos.y });
    this.boss.rightBranch.chunks.push(chunk);

    chunk = new BranchChunk(this.boss, this.boss.rightBranch.id, 0x00ff00);
    chunk.setPosition({ x: oPos.x - 1, y: oPos.y + 1 });
    this.boss.rightBranch.chunks.push(chunk);

    chunk = new BranchChunk(this.boss, this.boss.rightBranch.id, 0x00ff00);
    chunk.setPosition({ x: oPos.x - 1, y: oPos.y + 2 });
    this.boss.rightBranch.chunks.push(chunk);

    chunk = new BranchChunk(this.boss, this.boss.rightBranch.id, 0x00ff00);
    chunk.setPosition({ x: oPos.x, y: oPos.y + 2 });
    this.boss.rightBranch.chunks.push(chunk);

    chunk = new BranchChunk(this.boss, this.boss.rightBranch.id, 0x00ff00);
    chunk.setPosition({ x: oPos.x + 1, y: oPos.y + 2 });
    this.boss.rightBranch.chunks.push(chunk);

    chunk = new BranchChunk(this.boss, this.boss.rightBranch.id, 0x00ff00);
    chunk.setPosition({ x: oPos.x + 1, y: oPos.y + 1 });
    this.boss.rightBranch.chunks.push(chunk);

    chunk = new BranchChunk(this.boss, this.boss.rightBranch.id, 0x00ff00);
    chunk.setPosition({ x: oPos.x + 1, y: oPos.y });
    this.boss.rightBranch.chunks.push(chunk);
  }

  repost() {
    this.reloadSpots.forEach((spot) => {
      if (this.isDestinationEmpty(spot.position.x, spot.position.y)) {
        let element = null;
        if (Math.random() > 0.75) {
          element = this.createBarrelAt(spot.position);
        } else {
          element = this.createBoulderAt(spot.position);
        }
        element.setPosition(spot.position);
        this.moveables.push(element);
        this.onAddElement(element);
        element.addedToScene();
        this.objects[element.position.y][element.position.x] = element;
      }
    });
  }

  playerKilledByBranch() {
    this.playerKilled = true;
  }

  playerWon() {
    // console.log("YOU WON");
    this.bossDefeated();
  }

  drawProfecy() {
    const map = this.scene.children.getByName("layer_2");
    for (let i = 0; i <= 3; i++) {
      for (let j = 0; j <= 3; j++) {
        map.putTileAt(
          PIXEL_TO_TILEMAP_POSITION.WORLD_ART + j + i * 10,
          this.worldArtOriginPos.x + j,
          this.worldArtOriginPos.y + i,
          false,
          "layer_1"
        );
      }
    }
  }

  onKeyUp(event) {
    if (event.key === "1") {
      this.showDialog1();
    }
    if (event.key === "2") {
      this.showDialog2();
    }
    if (event.key === "3") {
      this.showDialog3();
    }
    if (event.key === "4") {
      this.showDialog4();
    }
    if (event.key === "5") {
      this.scene.events.emit("dialogue:updateCharacterName");
    }
    if (event.key === "9") {
      this.destroyObjectsByKind(CLASS_NAMES.ENEMY);
    }
    if (event.key === "7") {
      this.boss.takeBranchDamage("RIGHT_BRANCH", 1);
    }
    if (event.key === "8") {
      this.boss.takeBranchDamage("RIGHT_BRANCH", 5);
    }
    if (event.key === DIRS.LEFT) {
      this.growLeft();
    }
    if (event.key === DIRS.RIGHT) {
      this.growRight();
    }
    if (event.key === DIRS.UP) {
      this.growUp();
    }
    if (event.key === DIRS.DOWN) {
      this.growDown();
    }
  }

  showDialog1() {
    this.scene.events.once("dialogue:hidden", async () => {
      await this.awaitTicks(3);
      await this.playEarthquake(
        {
          x1: this.player.position.x,
          x2: this.player.position.x,
          y1: this.player.position.y,
          y2: this.player.position.y,
        },
        1
      );
      this.destroyObjectsInRange(
        {
          x1: this.player.position.x - 1,
          x2: this.player.position.x + 2,
          y1: this.player.position.y,
          y2: this.player.position.y + 2,
        },
        1
      );

      await this.awaitTicks(5);
      this.showDialog2();
    });
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "Doc"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_19.dialog_1.mary_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_19.dialog_1.dwarf_say_1")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_19.dialog_1.mary_say_2")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_19.dialog_1.dwarf_say_2")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_19.dialog_1.mary_say_3")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_19.dialog_1.dwarf_say_3")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_19.dialog_1.mary_say_4")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_19.dialog_1.dwarf_say_4")],
        },
      ],
    });
  }

  showDialog2() {
    this.scene.events.once("dialogue:hidden", async () => {
      // await this.awaitTicks(3)

      this.onNextTick((lvl) => lvl.startBattle());
    });
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "Doc"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_19.dialog_2.mary_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_19.dialog_2.dwarf_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_19.dialog_2.dwarf_say_2")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_19.dialog_2.dwarf_say_3")],
        },
      ],
    });
  }

  moveDwarfToExit() {
    // hack to auto move dwarf
    if (this.dwarfRun) {
      if (this.leader.leadingPath.length !== 0) {
        this.onNextTick(() => {
          this.leader.onPlayerMoves(this.leader.position);
          this.moveDwarfToExit();
        });
      } else {
        this.dwarfRun = false;
        this.replaceByEmpty(this.leader);
        this.leader = null;
        this.player.reconnect();
      }
    }
  }

  showDialog3() {
    this.scene.events.once("dialogue:hidden", async () => {
      this.dwarfRun = true;
      this.leader.leadingPath = [
        { x: this.leader.position.x + 1, y: this.leader.position.y },
        { x: this.leader.position.x + 1, y: this.leader.position.y },
        { x: this.leader.position.x + 2, y: this.leader.position.y },
        { x: this.leader.position.x + 2, y: this.leader.position.y },
        { x: this.leader.position.x + 3, y: this.leader.position.y },
        { x: this.leader.position.x + 3, y: this.leader.position.y },
      ];
      this.moveDwarfToExit();
    });
    this.scene.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Dwarf"],
      participantNames: ["Mary", "Marduk"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_19.dialog_3.mary_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_19.dialog_3.dwarf_say_1")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_19.dialog_3.dwarf_say_2")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("level_19.dialog_3.mary_say_2")],
        },
        {
          who: "closeUp_Dwarf",
          text: [translate("level_19.dialog_3.dwarf_say_3")],
        },
      ],
    });
  }

  showDialog4() {
    this.scene.events.emit("dialogue:show", {
      participants: [
        "closeUp_Mary",
        "closeUp_Marduk",
        "closeUp_Dwarf",
        "closeUp_Tiamat",
      ],
      participantNames: ["Mary", "Marduk", "Doc", "Tiamat"],
      conversation: [
        {
          who: "closeUp_Mary",
          text: [translate("level_1.dialog_1.mary_say_1")],
          options: [],
        },
      ],
    });
  }

  onInteractWith(el) {
    super.onInteractWith(el);

    if (el.isClass(Exit)) {
      this.onComplete();
    }

    if (el.order === 99) {
      this.showDialog3();
    }

    if (el.order === 0) {
      this.playTheProphecy();
    }
  }

  onAddElement(el) {
    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
    }

    if (el.isClass(Torch)) {
      el.ignite();
    }

    if (el.isClass(Interactive) && el.order === 0) {
      this.artSpot = el;
    }
    // interactive spots (excluding exit)
    if (el.isClass(Interactive) && !el.isClass(Exit) && el.order !== 0) {
      const isUpperHalf = el.position.y < this.config.length / 2;
      if (isUpperHalf) {
        this.reloadSpots.push(el);
      } else {
        this.batBirthSpots.push(el);
      }
    }
  }

  // Abushgidim loop
  async bossLoop() {
    if (this.boss.defeated) {
      return true;
    }
    this.onNextTick((lvl) => lvl.bossLoop());
    if (this.ticksCount < this.ticksCountForBossLoop) {
      this.ticksCount++;
      this.circularProgress.setValue(
        this.ticksCount / this.ticksCountForBossLoop
      );

      return false;
    } else {
      this.ticksCount = 0;
      this.circularProgress.reset();
    }

    // disconnect player
    this.player.disconnect();

    // pause enemies
    this.pause();

    // pan camera to boss
    await this.scene.rules.panAndFollow({
      x: UI.tileToScreen(this.boss.position.x),
      y: UI.tileToScreen(this.boss.position.y),
      width: 1,
      height: 1,
    });
    // birth of bats
    // await this.awaitTicks(3);
    await this.boss.birthBats();

    // repost
    this.repost();

    // pan camera to branches
    // grow branches
    await this.boss.growBranches();
    // await new Promise((res) => setTimeout(res, TICK_TIME * 5));

    // pan camera to player
    await this.scene.rules.panAndFollow(this.player.alien);

    if (!this.playerKilled) {
      // reconnect player
      this.player.reconnect();

      // resume enemies
      this.resume();
    } else {
      this.player.die();
      setTimeout(() => {
        // this.onCharacterDie(this.player);
      }, 2000)
    }
  }

  async bossDefeated() {
    // FADE OUT DRAMATIC MUSIC
    this.scene.tweens.add({
      targets: this.battleMusic,
      volume: 0,
      ease: "Linear",
      duration: 1000,
    });

    // DISCONNECT PLAYER
    this.player.disconnect();

    // MOVE DWARF AND SET INTERACTIVE SPOT
    this.repositionDwarfToEndLevel();

    // PAN CAMERA TO BOSS
    await this.scene.rules.panAndFollow({
      x: UI.tileToScreen(this.boss.position.x),
      y: UI.tileToScreen(this.boss.position.y),
      width: 1,
      height: 1,
    });

    // THROW GREEN EXPLOSIONS RANDOMLY OVER BOSS BODY
    const randomNegPosRange = (n) =>
      Math.floor(Math.random() * n) * (Math.round(Math.random()) ? 1 : -1);
    for (let i = 0; i < 20; i++) {
      this.setTickTimeout(() => {
        const exp = new GreenExplosion("GREEN_EXPLOSION", this);
        exp.setPosition({
          x: this.boss.position.x + randomNegPosRange(3),
          y: this.boss.position.y - 1 + randomNegPosRange(2),
        });
      }, i);
    }

    // BLINK BOSS
    const group = this.scene.add.group({
      classType: Phaser.GameObjects.Sprite,
      defaultKey: null,
      defaultFrame: null,
      active: true,
      maxSize: -1,
      runChildUpdate: false,
      createCallback: null,
      removeCallback: null,
      createMultipleCallback: null,
    });

    // FLASH BOSS AND DESTROY
    group.addMultiple(this.boss.body);
    await this.awaitTicks(10);
    const flash = this.scene.plugins
      .get("rexFlash")
      .add(group, { duration: TICK_TIME / 2, repeat: 20 });
    flash.flash();
    flash.once("complete", () => {
      group.clear();
      this.boss.body.forEach((s) => {
        this.scene.add
          .sprite(s.x, s.y)
          .setOrigin(0, 0.25)
          .play("ground_disolves");
        s.destroy();
      });
    });

    // QUAKE EFFECT
    this.playEarthquake(
      {
        x1: this.boss.position.x,
        x2: this.boss.position.x,
        y1: this.boss.position.y,
        y2: this.boss.position.y,
      },
      1
    );

    await this.awaitTicks(10);

    // CLEAR PATH BENEATH BOSS
    const condition = (el) => {
      const destroyable =
        el.isClass(CLASS_NAMES.BLOCK) ||
        el.isClass(CLASS_NAMES.WOMB) ||
        el.isClass(CLASS_NAMES.BOULDER);
      return destroyable;
    };
    this.destroyObjectsInRange(
      {
        x1: this.boss.position.x - 4,
        x2: this.boss.position.x + 4,
        y1: this.boss.position.y - 6,
        y2: this.boss.position.y + 2,
      },
      1,
      condition
    );

    await this.awaitTicks(10);

    // FADE IN MUSIC
    this.scene.rules.music.play();
    this.scene.tweens.add({
      targets: this.scene.rules.music,
      volume: 1,
      ease: "Linear",
      duration: 1000,
    });

    // PAN TO PLAYER
    await this.scene.rules.panAndFollow(this.player.alien);

    // RECONNECT PLAYER
    this.player.reconnect();
  }

  repositionDwarfToEndLevel() {
    this.teleportObject(this.leader, {
      x: this.boss.position.x,
      y: this.boss.position.y + 3,
    });
    this.leader.leadingPath = [
      { x: this.leader.position.x, y: this.leader.position.y + 1 },
      { x: this.leader.position.x, y: this.leader.position.y + 2 },
      { x: this.leader.position.x, y: this.leader.position.y + 3 },
      { x: this.leader.position.x, y: this.leader.position.y + 4 },
      { x: this.leader.position.x, y: this.leader.position.y + 5 },
      { x: this.leader.position.x, y: this.leader.position.y + 6 },
      { x: this.leader.position.x, y: this.leader.position.y + 7 },
      { x: this.leader.position.x, y: this.leader.position.y + 8 },
      { x: this.leader.position.x, y: this.leader.position.y + 9 },
      { x: this.leader.position.x, y: this.leader.position.y + 10 },
      { x: this.leader.position.x + 1, y: this.leader.position.y + 10 },
      { x: this.leader.position.x + 2, y: this.leader.position.y + 10 },
      { x: this.leader.position.x + 3, y: this.leader.position.y + 10 },
      { x: this.leader.position.x + 4, y: this.leader.position.y + 10 },
      { x: this.leader.position.x + 5, y: this.leader.position.y + 10 },
      { x: this.leader.position.x + 6, y: this.leader.position.y + 10 },
      { x: this.leader.position.x + 7, y: this.leader.position.y + 10 },
      { x: this.leader.position.x + 8, y: this.leader.position.y + 10 },
      { x: this.leader.position.x + 9, y: this.leader.position.y + 10 },
      { x: this.leader.position.x + 10, y: this.leader.position.y + 10 },
      { x: this.leader.position.x + 11, y: this.leader.position.y + 10 },
      { x: this.leader.position.x + 12, y: this.leader.position.y + 10 },
    ];
    const intElement = new Interactive(PIXEL_NAME.INTERACTION, this);
    intElement.order = 99;
    // intElement.ephemeral = false;
    this.interactiveElements[
      `${this.exit.position.x - 4}-${this.exit.position.y}`
    ] = intElement;
    intElement.setPosition({
      x: this.exit.position.x - 4,
      y: this.exit.position.y,
    });
  }

  destroy() {
    super.destroy();

    this.battleMusic.stop();

    this.branchesEnergyBars?.branch1?.progressBar?.destroy();
    this.branchesEnergyBars?.branch2?.progressBar?.destroy();
    this.branchesEnergyBars?.branch3?.progressBar?.destroy();
  }

  async playTheProphecy() {
    this.player.disconnect();

    this.onNextTick(() => {
      this.player.alien.play({ key: "brave_run_up", startFrame: 1 }, true);
      this.player.alien.anims.currentAnim.pause();
      this.leader.alien.play("dwarf_look_up");
    });

    await this.awaitTicks(8);
    this.leader.animIdle();
    this.showDialog1();
  }
  onComplete() {
    this.scene.events.off("levelcompleted");
    super.onComplete();
    this.scene.navigateToScene("KiStageCompleted");
  }
}

LevelKiFinale.key = "level_ki_finale";
export default LevelKiFinale;
